var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"redirector",attrs:{"href":_vm.url},on:{"click":function($event){return _vm.clicked($event)},"focusout":function($event){return _vm.focusout($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }